import { motion } from "framer-motion";
import { volunteering } from "@/data/resume";
import { HeartHandshake } from "lucide-react";

export default function Volunteering() {
  return (
    <section
      id="give-back"
      data-testid="volunteering-section"
      className="py-24 md:py-40 border-t border-[color:var(--border)]"
    >
      <div className="max-w-[1400px] mx-auto px-6 md:px-12">
        <div className="grid grid-cols-12 gap-y-8 mb-16 md:mb-24">
          <div className="col-span-12 md:col-span-5">
            <div className="text-xs font-mono-editorial uppercase text-[color:var(--muted)] tracking-[0.15em] mb-6">
              05 — Give Back
            </div>
            <h2 className="font-display text-5xl md:text-6xl font-light tracking-tight leading-[0.95]">
              Off <span className="font-serif-accent italic text-[color:var(--accent)]">the clock</span>, <br />
              in the community.
            </h2>
          </div>
          <div className="col-span-12 md:col-span-6 md:col-start-7 text-lg leading-relaxed text-[color:var(--charcoal)]/80 self-end">
            A running list of causes I&rsquo;ve backed — blood drives, women&rsquo;s welfare, poverty
            alleviation and teaching students with special needs.
          </div>
        </div>

        <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-px bg-[color:var(--border)] border border-[color:var(--border)]">
          {volunteering.map((v, i) => (
            <motion.div
              key={i}
              initial={{ opacity: 0, y: 20 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true, margin: "-80px" }}
              transition={{ duration: 0.6, delay: i * 0.06 }}
              className="bg-[color:var(--linen)] p-8 md:p-10 group hover:bg-[color:var(--linen-2)] transition-colors"
              data-testid={`volunteering-item-${i}`}
            >
              <div className="flex items-start justify-between mb-6">
                <HeartHandshake className="w-5 h-5 text-[color:var(--accent)]" />
                <span className="text-[11px] font-mono-editorial uppercase tracking-[0.15em] text-[color:var(--muted)]">
                  {v.dates}
                </span>
              </div>
              <div className="font-display text-xl md:text-2xl font-light leading-tight group-hover:text-[color:var(--accent)] transition-colors">
                {v.role}
              </div>
              <div className="mt-1 font-serif-accent italic text-[color:var(--charcoal)]/75">
                {v.org}
              </div>
              <p className="mt-4 text-sm leading-relaxed text-[color:var(--charcoal)]/80">
                {v.detail}
              </p>
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
}
